import React from 'react'
import Logo from "./logo.png"
const Header = () => {
  return (
  
    <nav >
    <div className="container-fluid">
      <a className="navbar-brand text-white mx-4 h1" href="#">
        <img src={Logo} alt="" width="60" height="60" className="d-inline-block align-text-center mx-3"/>
        Galery App
      </a>
    </div>
  </nav>

  )
}

export default Header